import axios from './index';

class TicketChatApi {
  static List = (data) => {
    let query = '?';
    if (data.searchTerm) {
      query += `search=${data.searchTerm}&`;
    }
    if (data.itemsPerPage) {
      query += `limit=${data.itemsPerPage}&`;
    }
    if (data.currentPage) {
      let offset = (data.currentPage - 1) * data.itemsPerPage;
      query += `offset=${offset}&`;
    }
    if (data.sort) {
      query += `sort=${data.sort}&`;
    }
    if (data.statusFilter) {
      query += `status=${data.statusFilter}&`;
    }
    if (data.priorityFilter) {
      query += `priority=${data.priorityFilter}&`;
    }
    return axios.get(`${base}/${query}`);
  };

  static SendMessage = (data) => {
    console.log('Data from chaat', data);
    let request = {
      ticket_id: data.ticketId,
      message: data.message || '',
      public: true,
    };
    return axios.post(`${base}/`, request);
  };

  static Update = (data) => {
    console.log('data :: ', data);
    let request = {
      name: data.name,
      display_order: data.display_order || 100,
      is_active: data.is_active,
    };
    return axios.put(`${base}/${data.id}`, request);
  };

  static Delete = (data) => {
    return axios.delete(`${base}/${data.id}`);
  };

  static getById = (id) => {
    return axios.get(`${base}/${id}`);
  };
}

let base = 'dashboard/ticket-chat';

export default TicketChatApi;
